export default class Vibrance {
	constructor() {
		this.minValue = -1;
		this.maxValue = 1;
		this.blockName = "Vibrance";
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".vibrance_slider")
			.on("input", _ => this.vibranceSliderHandler($(element)));
		$(element)
			.find(".vibrance_range")
			.on("change", _ => this.vibranceValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: this.blockName,
			version: '1.0',
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				vibrance: 0,
			},
		});
	}

	addPass() {
		let shaderPass = gpu.createVibrancePass();
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	vibranceSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let value = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, value);

		let block = lutify.getActiveBlock();
		block.values.vibrance = value;
		block.passes[0].uniforms.vibrance.value = value;
		gpu.render();
	}

	vibranceValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let value = UI.getAdjustmentBlock_rangeValue($el);

		if (value > this.maxValue) {
			value = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, value);
		}
		if (value < this.minValue) {
			value = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, value);
		}

		UI.setAdjustmentBlock_sliderValue($el, value);
		lutify.getActiveBlock().values.vibrance = value;
		lutify.getActiveBlock().passes[0].uniforms.vibrance.value = value;
		gpu.render();
	}


	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		UI.setAdjustmentBlock_rangeValue($block, values.vibrance);
		$block.find(".vibrance_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
